<template>
  <main class="app-content">
    <div class="app-title">
      <div class="row">
        <div class="col-md">
          <h1><i class="fa fa-dashboard"></i> {{ $t('overview') }}</h1>
        </div>
        <div class="col-md">
          <time-range-picker :model="filterFormModel" :label="$t('time')" @change="load" :defaultShortcut="0"></time-range-picker>
        </div>
      </div>
    </div>

    <div class="row" v-if="$store.state.user.role !== 'agency'">
      <div class="col-md-6 col-lg-3">
        <div class="widget-small info coloured-icon">
          <div class="icon"><font-awesome-icon icon="handshake"/></div>
          <div class="info">
            <h4>Client</h4>
            <p><span>{{ $t('new') }}: </span><b>{{ count.client }}</b></p>
            <p><span>{{ $t('online') }}: </span><b>{{ count.onlineClient }}</b></p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="widget-small info coloured-icon">
          <div class="icon"><i class="fa fa-user-plus"></i></div>
          <div class="info">
            <h4>{{ $t('user') }}</h4>
            <p><span>{{ $t('new') }}: </span><b>{{ count.user }}</b></p>
            <p><span>{{ $t('online') }}: </span><b>{{ count.onlineUser }}</b></p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <router-link to="/report/call">
          <div class="widget-small danger coloured-icon">
            <div class="icon"><font-awesome-icon icon="headphones-alt"/></div>
            <div class="info">
              <h4>{{ $t('call') }}</h4>
              <p><span>{{ $t('total') }}: </span><b>{{ count.callTotal }}</b></p>
              <p><span>{{ $t('connected') }}: </span><b>{{ count.callSuccess }}</b></p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="widget-small danger coloured-icon">
          <div class="icon"><font-awesome-icon icon="dollar-sign"/></div>
          <div class="info">
            <h4>{{ $t('finance') }}</h4>
            <p><span>{{ $t('deposit') }}: </span><b>{{ count.deposit | numFormat }}</b></p>
            <p><span>{{ $t('spent') }}: </span><b>{{ count.spent | numFormat }}</b></p>
          </div>
        </div>
      </div>
    </div>

    <!-- Tổng quan dành cho đại lý: vòng đời khách hàng + tài liệu API -->
    <agency-overview v-if="$store.state.user.role === 'agency'"></agency-overview>

    <!-- Lưới menu nhanh — lấp khoảng trống trang Tổng quan -->
    <div class="dashboard-menu-search">
      <i class="fa fa-search dashboard-menu-search-icon"></i>
      <input type="text" v-model="menuSearchQuery" :placeholder="$t('searchMenu')" />
      <i v-if="menuSearchQuery" class="fa fa-times dashboard-menu-search-clear" @click="menuSearchQuery = ''"></i>
    </div>

    <div class="row">
      <div class="col-md-6 col-lg-4" v-for="group in filteredGroups" :key="group.key">
        <div class="tile dashboard-menu-card">
          <h4 class="tile-title">
            <span class="dashboard-menu-icon"><font-awesome-icon :icon="group.icon" /></span>
            {{ group.name }}
          </h4>
          <ul class="dashboard-menu-list">
            <li v-for="item in group.items" :key="item.href">
              <router-link :to="item.href" :title="item.name">
                <i class="fa fa-angle-right"></i><span>{{ item.name }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="!filteredGroups.length" class="col-12">
        <div class="tile text-center text-muted">{{ $t('noMenuResult') }}</div>
      </div>
    </div>
  </main>
</template>

<script>
import TimeRangePicker from "../components/TimeRangePicker";
import AgencyOverview from "./AgencyOverview";
import { buildMenuItems, checkMenuRole, menuMessages } from "../menu";

export default {
  components: { TimeRangePicker, AgencyOverview },
  data: function () {
    return {
      count: {},
      filterFormModel: {},
      menuSearchQuery: '',
    };
  },
  computed: {
    // Các nhóm menu (có mục con) đã lọc theo quyền của user hiện tại.
    // Bỏ qua mục "Tổng quan" (không có items, lại chính là trang này).
    menuGroups: function () {
      const role = this.$store.state.user.role;
      return buildMenuItems(this.$t.bind(this))
        .filter(group => group.items && group.items.length && checkMenuRole(group.roles, role))
        .map(group => ({
          key: group.href || group.name,
          name: group.name,
          icon: group.icon,
          items: group.items.filter(item => checkMenuRole(item.roles, role)),
        }))
        .filter(group => group.items.length);
    },
    // Lọc theo từ khoá tìm kiếm (không phân biệt hoa thường & dấu tiếng Việt).
    filteredGroups: function () {
      const q = this.normalizeText(this.menuSearchQuery).trim();
      if (!q) return this.menuGroups;
      return this.menuGroups
        .map(group => ({
          ...group,
          items: group.items.filter(item => this.normalizeText(item.name).indexOf(q) !== -1),
        }))
        .filter(group => group.items.length);
    },
  },
  methods: {
    // Bỏ dấu tiếng Việt + lowercase để tìm kiếm dễ khớp.
    normalizeText(str) {
      return (str || '').toString().toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd');
    },
    load() {
      if (this.$store.state.user.role !== 'agency') {
        this.$bgService.get('/dashboard/count', { params: this.filterFormModel }).then(response => {
          if (response.data) this.count = response.data;
        });
      }
    },
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        ...menuMessages.en,
        overview: 'Overview',
        user: 'User',
        new: 'New',
        online: 'Online',
        call: 'Call',
        total: 'Total',
        connected: 'Connected',
        deposit: 'Deposit',
        spent: 'Spent',
        finance: 'Finance',
        time: 'Time',
        searchMenu: 'Search menu...',
        noMenuResult: 'No matching menu found',
      },
      vi: {
        ...menuMessages.vi,
        overview: 'Tổng quan',
        user: 'Người dùng',
        new: 'Mới',
        online: 'Online',
        call: 'Cuộc gọi',
        total: 'Tổng',
        connected: 'Kết nối',
        deposit: 'Khách nạp',
        spent: 'Khách tiêu',
        finance: 'Tài chính',
        time: 'Thời gian',
        searchMenu: 'Tìm kiếm menu...',
        noMenuResult: 'Không tìm thấy menu phù hợp',
      }
    }
  },
};
</script>

<style scoped>
.dashboard-menu-card {
  height: calc(100% - 24px);
  margin-bottom: 24px;
}
.dashboard-menu-card .tile-title {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  font-size: 15px;
}
.dashboard-menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-right: 8px;
  border-radius: 6px;
  background: #f0f3f7;
  color: #4a90d9;
  font-size: 14px;
}
/* Ô tìm kiếm menu */
.dashboard-menu-search {
  position: relative;
  max-width: 420px;
  margin: 0 0 18px;
}
.dashboard-menu-search input {
  width: 100%;
  height: 38px;
  padding: 0 34px 0 36px;
  border: 1px solid #dfe3e8;
  border-radius: 20px;
  font-size: 13px;
  color: #5a5a5a;
  background: #fff;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.dashboard-menu-search input:focus {
  border-color: #4a90d9;
  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.12);
}
.dashboard-menu-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #b0b8c4;
  font-size: 13px;
}
.dashboard-menu-search-clear {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #b0b8c4;
  font-size: 13px;
  cursor: pointer;
}
.dashboard-menu-search-clear:hover {
  color: #e74c3c;
}

/* Danh sách mục con — 2 cột thẳng hàng */
.dashboard-menu-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 1px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.dashboard-menu-list li {
  min-width: 0;
}
.dashboard-menu-list li a {
  display: flex;
  align-items: center;
  padding: 5px 8px;
  border-radius: 4px;
  color: #5a5a5a;
  font-size: 13px;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
}
.dashboard-menu-list li a:hover {
  background: #f5f7fa;
  color: #4a90d9;
}
.dashboard-menu-list li a .fa {
  flex: 0 0 auto;
  margin-right: 6px;
  color: #b0b8c4;
  font-size: 11px;
}
.dashboard-menu-list li a span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 575px) {
  .dashboard-menu-list {
    grid-template-columns: 1fr;
  }
}
</style>
